module.exports = __webpack_public_path__ + "static/media/sponcer_Kabob.dbf7aaea.png";